import { Pages, Roles } from '../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../hooks/useHasPermissions';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import UserManagement, {
    useEnableDisplayUserManagement,
    UserManagementBlockPage
} from '../../components/UserManagement';

export const UsersRouting = (props: LogicalRouteImportProps) => {
    const disabled = !useHasPermissions({ permission: Pages.USERS, role: Roles.VIEWER });

    return (
        <LogicalRoute
            {...props}
            component={UserManagement}
            disabled={disabled}
            blockPageComponent={UserManagementBlockPage}
            displayBlockPage={!useEnableDisplayUserManagement()}
        />
    );
};
